import Vue from 'vue';
import Router from 'vue-router';
import { mainRouterList, baseRouterList } from '@/config/router.config';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [...baseRouterList, ...mainRouterList],
});
